<template>
  <div class="login_bg">
    <div class="container">
      <div class="log_img">
        <router-link to="/home">
          <img src="../assets/images/logo2.png" alt="" srcset="" />
        </router-link>
      </div>
      <div class="log_qr">
        <div class="qr_title">
          <div class="h1_iocn">
            <img src="../assets/images/icon14.png" alt="" srcset="" />
          </div>
          <div class="h1_text">微信登录</div>
        </div>
        <div class="qrcodecontent">
          <img :src="codePath" class="qrcode" alt="加载中" />
          <div
            class="successScan"
            v-bind:data-tips="tips"
            v-if="scanSuccess"
          ></div>
        </div>
        <div class="qr_text">微信扫码即可直接完成注册和登录</div>
        <!-- <div class="qr_btn">下次自动登录</div> -->
      </div>
      <div class="log_bottom">
        注册和登录即表示同意
        <router-link to="/" class="link">隐私协议</router-link> 和
        <router-link to="/" class="link">在线服务协议</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, onUnmounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { posts } from '../utils/posts'
export default {
  setup () {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const codePath = ref('')
    const code = ref('')
    const scanSuccess = ref(false)
    const tips = ref('扫码成功')
    let count = 0
    const interval = setInterval(() => {
      count++
      getUser()
    }, 1500)

    const getUser = () => {
      posts('users/scanlogin', { code: code.value }).then((res) => {
        const returnCode = res.data.code
        if (returnCode === 2) {
          // 扫描成功
          clearInterval(interval)
          store.state.userInfo = res.data.data
          localStorage.setItem('userInfo', JSON.stringify(res.data.data))
          let targetPath = route.query.returnUrl
          targetPath = targetPath || '/mine/order'
          router.push({ path: targetPath })
        } else if (returnCode === 1) {
          // 已扫描
          scanSuccess.value = true
        }
        if (count > 99) {
          clearInterval(interval)
          scanSuccess.value = true
          tips.value = '二维码失效'
        }
      })
    }

    onMounted(() => {
      const max = 6
      const min = 6
      var returnStr = ''
      var range = max ? Math.round(Math.random() * (max - min)) + min : min
      var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      for (var i = 0; i < range; i++) {
        var index = Math.round(Math.random() * (arr.length - 1))
        returnStr += arr[index]
      }
      code.value = Date.parse(new Date()) + returnStr
      codePath.value = `https://mingyou.darga.cn/api/users/getscancode?code=${code.value}`
    })
    onUnmounted(() => {
      clearInterval(interval)
    })
    return {
      codePath,
      code,
      scanSuccess,
      tips
    }
  }
}
</script>
<style lang="scss" scoped>
.login_bg {
  height: 100vh;
  background: url(../assets/images/login_bg.png) center no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .container {
    width: 552px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    .log_bottom {
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
      margin: 47px 0 0 0;
      .link {
        color: white;
      }
    }
    .log_qr {
      width: 552px;
      height: 560px;
      background: #ffffff;
      opacity: 1;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .qr_btn {
        font-size: 16px;
        font-weight: 400;
        color: #999999;
      }
      .qr_text {
        font-size: 18px;
        font-weight: 400;
        line-height: 24px;
        color: #3e3a39;
        margin: 36px 0 24px 0;
      }
      .qrcodecontent {
        margin-top: 60px;
        text-align: center;
        position: relative;
        .qrcode {
          width: 280px;
          height: 280px;
        }
        .successScan {
          position: absolute;
          width: 280px;
          height: 280px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          top: 0;
        }
        .successScan::after {
          position: absolute;
          content: attr(data-tips);
          font-weight: bold;
          font-size: 16px;
          left: 0;
          right: 0;

          margin: 0 auto;
        }
        .successScan::before {
          position: absolute;
          content: "";
          background-color: rgba(255, 255, 255, 0.9);

          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        }

        .tips {
          margin-top: 20px;
        }
        .tips:first-child {
          font-size: 20px;
          color: #999;
        }
        .tips:last-child {
          color: #333;
        }
      }
      .qr_img {
        width: 300px;
        height: 300px;
        overflow: hidden;
        margin: 56px 0 36px 0;
        background: chartreuse;
      }
      .qr_title {
        width: 100%;
        height: 67px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: center;
        align-items: center;
        .h1_text {
          font-size: 20px;
          font-weight: 600;
          color: #3e3a39;
        }
        .h1_iocn {
          width: 32px;
          height: 26px;
          overflow: hidden;
          margin: 0 8px 0 0;
        }
      }
    }
    .log_img {
      width: 256px;
      height: 60px;
      margin: 0 0 64px 0;
      overflow: hidden;
    }
  }
}
</style>
